<template>
  <div
    class="medal_detailList"
    :class="renderMode"
    v-show="data && data.length > 0"
  >
    <span
      class="medal_item"
      v-for="(item, index) in data"
      :key="index"
      :class="[chooseState, item.isChooseFlag ? 'chooseAct' : '']"
      @click="chooseStateIsClickItem(item)"
    >
      <!-- <span class="medal_top_icon" :class="item.medalType"></span> -->
      <span class="medal_icon" :class="item.medalType"></span>
      <span
        class="checkListMedal_date"
        v-if="renderMode === 'checkList'"
        v-text="item.formatDate"
      ></span>
      <span class="sport_infor">
        <span class="matchName" v-text="item.matchName"></span>
        <span class="palyerNames" v-text="item.palyerNames"></span>
      </span>
      <!-- <span class="medal_date" v-text="item.medalDate"></span> -->
      <div class="delegation_infor">
        <span class="delegationInfor_row1">
          <span class="logo" :class="item.delegationLogo ? 'isLogo' : ''">
            <img v-if="item.delegationLogo" :src="item.delegationLogo" />
          </span>
          <span class="logoCode" v-text="item.delegationId"></span>
        </span>
        <span class="delegationInfor_row2" v-text="item.delegationName"></span>
      </div>
      <span class="item_absChoose" v-show="chooseState === 'choose'">
        <span class="checkbox_item">
          <svg
            t="1693726421166"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="21127"
            width="80%"
            height="80%"
          >
            <path
              d="M892.064 261.888a31.936 31.936 0 0 0-45.216 1.472L421.664 717.248l-220.448-185.216a32 32 0 1 0-41.152 48.992l243.648 204.704a31.872 31.872 0 0 0 20.576 7.488 31.808 31.808 0 0 0 23.36-10.112L893.536 307.136a32 32 0 0 0-1.472-45.248z"
              p-id="21128"
            ></path>
          </svg>
        </span>
      </span>
    </span>
    <!-- <p class="noDataClass" v-show="noData">暂无数据</p> -->
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'medal_detailList',
  mixins: [cup_base_data_mixin],
  props: {
    data: {
      type: [Array, null],
      default: null,
    },
    chooseState: {
      type: String,
      default: 'default', //['default', 'choose', 'none'] none：没有鼠标经过效果
    },
    localStorageName: {
      type: String,
      default: '',
    },
    localStorageSaveDate: {
      type: String,
      default: '',
    },
    renderMode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      //   list: null,
    }
  },
  methods: {
    chooseStateIsClickItem(item) {
      console.debug(item)
      if (this.chooseState === 'choose' && this.localStorageName) {
        let chooseObj = this.$localStorage.getItem(this.localStorageName)
          ? JSON.parse(this.$localStorage.getItem(this.localStorageName))
          : {
              cid: this.currCid,
              // date: this.localStorageSaveDate,
              chooseItemArr: [],
              chooseIdArr: [],
            }
        if (chooseObj.cid === this.currCid) {
          if (chooseObj.chooseItemArr.length === 0) {
            let newItem = JSON.parse(JSON.stringify(item))
            newItem.isChooseFlag = true
            chooseObj.chooseItemArr.push(newItem)
            chooseObj.chooseIdArr.push(item.chooseId)
          } else {
            let chooseItemArr = []
            let chooseIdArr = []
            chooseObj.chooseItemArr.forEach((chooseItem) => {
              if (chooseItem.chooseId !== item.chooseId) {
                chooseItemArr.push(chooseItem)
                chooseIdArr.push(chooseItem.chooseId)
              }
            })
            if (chooseItemArr.length === chooseObj.chooseItemArr.length) {
              let newItem = JSON.parse(JSON.stringify(item))
              newItem.isChooseFlag = true
              chooseItemArr.push(newItem)
              chooseIdArr.push(item.chooseId)
            }
            chooseObj.chooseItemArr = chooseItemArr
            chooseObj.chooseIdArr = chooseIdArr
          }
          this.$localStorage.setItem(
            this.localStorageName,
            JSON.stringify(chooseObj)
          )
          this.$emit('changeChooseNumEvent', {
            localStorageName: this.localStorageName,
            val: chooseObj.chooseIdArr.length,
            init: false,
          })
          console.debug('chooseObj:', chooseObj)
        } else {
          console.error('错误：赛事不同')
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.medal_detailList {
  width: 100%;
  height: auto;
  display: flex;
  display: -webkit-flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  padding-bottom: 2.778vw;
  &.checkList {
    padding-bottom: 0;
    .medal_item {
      margin-bottom: 0;
      border-radius: 0;
      .sport_infor {
        width: calc(100% - 13.878vw - 11.1vw);
      }
      &.choose {
        padding: 0.833vw 1.042vw 0.833vw 4.164vw;
      }
    }
  }
  .medal_item {
    position: relative;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: auto;
    padding: 0.972vw 1.042vw 0.972vw 1.388vw;
    background-color: var(--mixtmt_greyColor8);
    border-radius: 0.556vw;
    margin-bottom: 1.38vw;
    transition: padding 0.3s linear;
    &.choose {
      padding: 0.972vw 1.042vw 0.972vw 4.164vw;
      .item_absChoose {
        width: 4.164vw;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        .checkbox_item {
          width: 1.388vw;
          height: 1.388vw;
          border-radius: 0.208vw;
          border: 1px solid var(--mixtmt_subColor1_1);
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          background-color: var(--mixtmt_whiteColor);
          /* &.act {
                  background-color: var(--mixtmt_subColor1_1);
                  color: var(--mixtmt_whiteColor);
                } */
          svg {
            opacity: 0;
            fill: var(--mixtmt_whiteColor);
            transition: all 0.3s linear;
          }
        }
      }
      &.chooseAct {
        .checkbox_item {
          background-color: var(--mixtmt_subColor1_1);
          svg {
            opacity: 1;
          }
        }
      }
    }
    .medal_top_icon {
      margin-right: 0.694vw;
      position: relative;
      width: 4.16vw;
      height: 2.778vw;
      overflow: hidden;
      &::before {
        position: absolute;
        top: 50%;
        left: 50%;
        z-index: 2;
        content: '\20';
        transform: translate(-50%, -50%);
        width: 2.778vw;
        height: 1.25vw;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
      }
      &.ME_GOLD {
        background: linear-gradient(137deg, #eed99f 0%, #b09445 100%);
        &::before {
          background-image: var(--mixtmt_medalist_top1_icon);
        }
      }
      &.ME_SILVER {
        background: linear-gradient(137deg, #dbe1e8 0%, #95999c 100%);
        &::before {
          background-image: var(--mixtmt_medalist_top2_icon);
        }
      }
      &.ME_BRONZE {
        background: linear-gradient(137deg, #f5c9ad 0%, #a86e4b 100%);
        &::before {
          background-image: var(--mixtmt_medalist_top3_icon);
        }
      }
    }
    .medal_icon {
      width: 2.778vw;
      height: 2.778vw;
      overflow: hidden;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: center;
      &.ME_GOLD {
        background-image: var(--mixtmt_gold_num_icon);
      }
      &.ME_SILVER {
        background-image: var(--mixtmt_silver_num_icon);
      }
      &.ME_BRONZE {
        background-image: var(--mixtmt_bronze_num_icon);
      }
    }
    .checkListMedal_date {
      width: 6.94vw;
      font-size: 1.25vw;
      text-align: center;
      font-weight: bold;
    }
    .sport_infor {
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: flex-start;
      flex-direction: column;
      width: calc(100% - 13.878vw);
      padding: 0 3.47vw 0 2.08vw;
      height: auto;
      color: var(--mixtmt_blackColor);
      .matchName,
      .palyerNames {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .matchName {
        font-size: 1.25vw;
        line-height: 2.2vw;
        height: 2.2vw;
      }
      .palyerNames {
        font-size: 1.11vw;
        line-height: 2.08vw;
        height: 2.08vw;
      }
    }
    .medal_date {
      width: 5.55vw;
      font-size: 1.11vw;
      color: var(--mixtmt_greyColor2);
    }

    .delegation_infor {
      width: 11.1vw;
      height: auto;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: flex-start;
      flex-direction: column;
      .delegationInfor_row1 {
        width: 100%;
        height: 2.2vw;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        .logo {
          width: 3.3vw;
          height: 2.2vw;
          overflow: hidden;
          background-color: var(--mixtmt_greyColor0);
          &.isLogo {
            background-color: transparent;
          }
          img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        .logoCode {
          width: 4.16vw;
          height: 2.778vw;
          overflow: hidden;
          line-height: 2.778vw;
          font-size: 1.38vw;
          text-align: center;
          /* background-color: var(--mixtmt_greyColor7); */
          color: var(--mixtmt_greyColor4);
        }
      }
      .delegationInfor_row2 {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        line-height: 2.08vw;
        font-size: 1.25vw;
        color: var(--mixtmt_greyColor2);
      }
    }
    .item_absChoose {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 2;
      width: 0;
      height: 100%;
      transition: width 0.3s linear;
    }
  }
  .noDataClass {
    position: absolute;
    bottom: -4.166vw;
    left: 0;
    z-index: 2;
    width: 100%;
    line-height: 4.166vw;
    text-align: center;
    font-size: 0.972vw;
    color: var(--mixtmt_greyColor2);
    border-top: 1px solid var(--mixtmt_greyColor0);
    border-bottom: 1px solid var(--mixtmt_greyColor0);
  }
}

.mixtmt_pc .medal_detailList {
  .medal_item:not(.none) {
    &.choose {
      &:hover {
        cursor: pointer;
        /* background-color: var(--mixtmt_mainColor);
        color: var(--mixtmt_whiteColor);
        .sport_infor,
        .medal_date {
          color: var(--mixtmt_whiteColor);
        }
        .delegation_infor {
          .delegationInfor_row1 {
            .logoCode {
              color: var(--mixtmt_whiteColor);
            }
          }
          .delegationInfor_row2 {
            color: var(--mixtmt_whiteColor);
          }
        } */
      }
    }
    &:hover {
      /* cursor: pointer; */
      background-color: var(--mixtmt_mainColor);
      color: var(--mixtmt_whiteColor);
      .sport_infor,
      .medal_date {
        color: var(--mixtmt_whiteColor);
      }
      .delegation_infor {
        .delegationInfor_row1 {
          .logoCode {
            color: var(--mixtmt_whiteColor);
          }
        }
        .delegationInfor_row2 {
          color: var(--mixtmt_whiteColor);
        }
      }
    }
    &.choose.chooseAct {
      cursor: pointer;
      background-color: var(--mixtmt_mainColor);
      color: var(--mixtmt_whiteColor);
      .sport_infor,
      .medal_date {
        color: var(--mixtmt_whiteColor);
      }
      .delegation_infor {
        .delegationInfor_row1 {
          .logoCode {
            color: var(--mixtmt_whiteColor);
          }
        }
        .delegationInfor_row2 {
          color: var(--mixtmt_whiteColor);
        }
      }
    }
  }
}
</style>
